import styled from 'styled-components'

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`

export const NotFoundHeading = styled.h1`
  color: #64748b;
  font-size: 32px;
  font-family: 'Roboto';
`
export const NotFoundPara = styled.p`
  color: #7b8794;
  font-size: 14px;
  font-family: 'Roboto';
`

export const Img = styled.img`
  height: 250px;
  width: 250px;
`

export default NotFoundContainer
